import { EntityModules, ProtectorType } from 'core/constants';

import { inheritQuestionShape, type QuestionShape } from './inherit';
import type { FormBuilderMode } from './mode';
import type { AuditQuestion, AuditSection } from './types';

export const ONE_SITE_QUESTION = "This template already has a Site question. It sets the assessment's site.";

export const SITE_QUESTION_NOTICE = "This question sets the assessment's site.";

export const SITE_RESPONSE_KEY = `lookup-${EntityModules.Sites}`;

const isSiteShape = (shape: QuestionShape): boolean =>
  shape.questionType === ProtectorType.Lookup && shape.lookupType === EntityModules.Sites;

export const isSiteQuestion = (mode: FormBuilderMode, question: AuditQuestion): boolean =>
  mode.singleSiteQuestion && isSiteShape(question);

export const siteQuestions = (mode: FormBuilderMode, sections: AuditSection[]): AuditQuestion[] =>
  sections.flatMap((section) => section.questions).filter((question) => isSiteQuestion(mode, question));

export const otherSiteQuestion = (
  mode: FormBuilderMode,
  sections: AuditSection[],
  exceptKey: string
): AuditQuestion | undefined => siteQuestions(mode, sections).find((question) => question.key !== exceptKey);

export const newQuestionShape = (mode: FormBuilderMode, source?: AuditQuestion): QuestionShape => {
  const shape = inheritQuestionShape(source);
  return mode.singleSiteQuestion && isSiteShape(shape) ? { questionType: ProtectorType.ShortText } : shape;
};
